import {
  HomeOutlined,
  KeyOutlined,
  LoadingOutlined,
  MailOutlined,
  MobileOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Alert, Button, Checkbox, Col, Divider, Form, Input, Row, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { register } from "../../../Actions/api";
import "./SignUp.css";
import TermAndCondition from "../Contact/TermAndConditionModal";

function SignUp() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [open, setOpen] = useState(false);

  const onFinish = async () => {
    const values = await form.validateFields();
    if (values) {
      setLoading(true);
    }
    dispatch(
      register(
        values.name,
        values.email,
        values.username,
        values.mobile,
        // values.password,
        // values.confirmPassword,
        values.partnerName,
        values.partnerEmail,
        values.registration,
        values.partnerMobile
      )
    )
      .then(() => {
        setLoading(false);
        form.resetFields();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onCheckboxChange = async (e) => {
    await setChecked(e.target.checked);
    form.validateFields(["checkTerm"]);
  };

  const validation = (rule, value, callback) => {
    if (checked) {
      return callback();
    }
    return callback("Please accept the terms and conditions");
  };

  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true;
    if (message !== undefined) {
      try {
        if (message[0] === true) {
          setHidden(true);
        }
      } catch {
        setHidden(false);
      }
    }
    return () => (isMounted = false);
  }, [message]);

  return (
    <div className="SignUp-container" justify="center">
      <div className="signup-title">Sign Up</div>
      <div className="sub-signup-title">Your Developer Account</div>
      <Row>
        
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          {message && (
            <div>
              {message[0] === true ? (
                <>
                  <h1 className="successRegisterSignUp">
                    Thank for your registration. <br />
                    We'll contact you within a few working days.
                  </h1>
                  <p style={{ textAlign: "center" }}>
                    <br />
                    Redirect Back to <Link to="/">Home</Link> Page
                  </p>
                </>
              ) : (
                <Alert
                  message={
                    message[1] != null ? (
                      message[1]
                    ) : (
                      <ul style={{ paddingLeft: "20px" }}>
                        {message[2].map((m) => (
                          <li key={m}>{m}</li>
                        ))}
                      </ul>
                    )
                  }
                  type="error"
                />
              )}
            </div>
          )}
          <Form
            form={form}
            layout="vertical"
            name="basic"
            className="Signup_form"
            hidden={hidden}
          >
            <Row gutter={[12, 8]}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">Name</label>}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Name!",
                    },
                  ]}
                >
                  <Input addonBefore={<UserOutlined />} size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">E-mail</label>}
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your E-mail!",
                    },
                  ]}
                >
                  <Input addonBefore={<MailOutlined />} size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[12, 8]}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">Username</label>}
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please input your username!",
                    },
                    {
                      min: 6,
                      message: "Please make sure your username over 6 character!",
                    }
                  ]}
                >
                  <Input addonBefore={<SolutionOutlined />} size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">Mobile</label>}
                  name="mobile"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Mobile!",
                    },
                  ]}
                >
                  <Input addonBefore={<MobileOutlined />} size="large" />
                </Form.Item>
              </Col>
            </Row>
            {/* <Row gutter={[12, 8]}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">Password</label>}
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                    {
                      min: 8,
                      message: "Password must be minimum 8 characters.",
                    },
                    {
                      pattern: "(?=.*[a-z])",
                      message: "At least one lower case",
                    },
                    {
                      pattern: "(?=.*[A-Z])",
                      message: "At least one Upper case",
                    },
                    {
                      pattern: "(?=.*[@$!%*#?&_-])",
                      message: "At least one Special Character",
                    },
                    {
                      pattern: "(?=.*[0-9])",
                      message: "At least one Digital Number",
                    },
                  ]}
                >
                  <Input.Password addonBefore={<KeyOutlined />} size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={
                    <label className="label_login">Confirm Password</label>
                  }
                  name="confirmPassword"
                  dependencies={["password"]}
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The two passwords that you entered do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password addonBefore={<KeyOutlined />} size="large" />
                </Form.Item>
              </Col>
            </Row> */}
            <Divider />
            <label style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              Entity Info
            </label>
            <br />
            <br />
            <Row gutter={[12, 8]}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">Entity Name</label>}
                  name="partnerName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Entity Name!",
                    },
                  ]}
                >
                  <Input addonBefore={<UserOutlined />} size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">Entity Email</label>}
                  name="partnerEmail"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please input your Entity Email!",
                    },
                  ]}
                >
                  <Input addonBefore={<MailOutlined />} size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[12, 8]}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={
                    <label className="label_login">Registration Number</label>
                  }
                  name="registration"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Registration Number!",
                    },
                  ]}
                >
                  <Input addonBefore={<HomeOutlined />} size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  label={<label className="label_login">Entity Mobile</label>}
                  name="partnerMobile"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Entity Mobile!",
                    },
                  ]}
                >
                  <Input addonBefore={<MobileOutlined />} size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              name="checkTerm"
              rules={[
                {
                  validator: validation,
                },
              ]}
            >
              <Checkbox checked={checked} onChange={onCheckboxChange}>
                <label>
                  I hereby declare that I am an duly authorized representative
                  and any entity I may represent in connection with my use of
                  Etiqa API Portal.{" "}
                  <span className="hoverSpan" style={{ color: "#1890ff" }} onClick={() => setOpen(true)}>
                Terms and Conditions of Use
              </span>
                </label>
              </Checkbox>
            </Form.Item>
            <Form.Item style={{ textAlign: "center", marginTop: "10px" }}>
              <Button
                type="primary"
                onClick={onFinish}
                size="large"
                className="button_login"
              >
                {loading && <LoadingOutlined />}
                Sign Up
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Modal
          title="Terms And Conditions"
          centered
          visible={open}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
          width={1000}
          footer={[
            <Button key="submit" type="primary" onClick={() => setOpen(false)}>
              Ok
            </Button>,
          ]}
        >
          <TermAndCondition />
        </Modal>
      </Row>
    </div>
  );
}

export default SignUp;
